import React, {Fragment} from "react";
import Builder from 'react-querybuilder';
import Button from "../../../../form/Button";
import Select from "../../../../form/Select";
import TextInput from "../../../../form/TextInput";
import classNames from "classnames";
import { formatQuery } from 'react-querybuilder';
import CheckBox from "../../../../form/CheckBox";
import ValueEditor from "./ValueEditor";
import parseQuery from "./parseQuery";
import unparseQuery from "./unparseQuery";
import Collapse from "../../../../layout/Collapse";
import {optionsTemplate, PersonSelect} from "../../../../../utils/formatters";
import DateTimeInput from "../../../../form/DateTimeInput";
import Modal from "../../../../layout/Modal";
import NewsletterFilterEditor from "../../../NewsletterFilterEditor";
import FragmentEditor from "../../../FragmentEditor";
import Portal from "../../../../layout/Portal";
import ComponentConfig from "../../../../form/ComponentConfig";
import NewsletterFilterList from "../../../lists/NewsletterFilterList";
import {get} from "../../../../../utils/dotutils";
import {deleteComponent, loadComponent, saveComponent} from "../../../../../utils/components";
import {connect} from "src/store";
import {empty} from "locutus/php/var";
import debounce from "../../../../../utils/debounce";

export const optinFields = [
    {
        name: 'source',
        label: 'Forrás',
        operators: [
            {
                name: '=',
                label: '='
            },
            {
                name: '!=',
                label: '!='
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="OptInSource"
                    storeType="local"
                    placeholder="Forrás"
                    label={false}
                    labelKey="name"
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'person_id',
        label: 'Személy',
        operators: [
            {
                name: '=',
                label: '='
            },
            {
                name: '!=',
                label: '!='
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="person"
                    storeType="remote"
                    placeholder="Személy"
                    label={false}
                    optionsTemplate={PersonSelect}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'sent',
        label: 'Küldés',
        operators: [
            {
                name: '=',
                label: 'Elküldve'
            },
            {
                name: '!=',
                label: 'Nem küldtük'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="Newsletter"
                    storeType="remote"
                    placeholder="Hírlevél"
                    label={false}
                    optionsTemplate={optionsTemplate("Newsletter")}
                    selectedOptionTemplate={(props) => <Fragment>{props[props.labelKey]} <i>(#{props[props.valueKey]})</i></Fragment>}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'opened',
        label: 'Nyitás',
        operators: [
            {
                name: '=',
                label: 'Nyitotta'
            },
            {
                name: '!=',
                label: 'Nem nyitotta'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="Newsletter"
                    storeType="remote"
                    placeholder="Hírlevél"
                    label={false}
                    optionsTemplate={optionsTemplate("Newsletter")}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'address.postcode',
        label: 'Irányítószám',
        operators: [
            { name: '=', label: '=' },
            { name: '!=', label: '!=' },
            { name: '<', label: '<' },
            { name: '>', label: '>' },
            { name: '<=', label: '<=' },
            { name: '>=', label: '>=' },
            { name: 'between', label: 'között' },
        ],
        valueEditor: (props) => {
            if (props.operator === "between") {
                const values = JSON.parse(JSON.stringify(Array.isArray(props.value) ? props.value : (props.value ? [props.value, null] : [null, null])));
                return <Fragment>
                    <div className="flex-grow-1">
                        <TextInput
                            placeholder="1123"
                            label={false}
                            value={(values[0] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[0] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                    <div className="flex-grow-1">
                        <TextInput
                            placeholder="2311"
                            label={false}
                            value={(values[1] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[1] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                </Fragment>;
            }
            return <div className="flex-grow-1">
                <TextInput
                    placeholder="1123"
                    label={false}
                    value={props.value}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'email',
        label: 'Email',
        operators: [
            {
                name: '=',
                label: '='
            }
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <TextInput
                    placeholder="email@domain.com"
                    label={false}
                    value={props.value}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'purchaseitem',
        label: 'Termékvásárlás',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="product"
                    storeType="remote"
                    placeholder="Vonalkód vagy cím"
                    label={false}
                    optionsTemplate={optionsTemplate("product")}
                    value={props.value}
                    valueKey="base_product_id"
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'purchaseitem.author',
        label: 'Termékvásárlás (szerző alapján)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="author"
                    storeType="remote"
                    placeholder="Szerző neve"
                    label={false}
                    optionsTemplate={optionsTemplate("author")}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'purchaseitem.category',
        label: 'Termékvásárlás (típus szerint)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="ProductCategory"
                    storeType="local"
                    placeholder="Termék kategória"
                    label={false}
                    optionsTemplate={optionsTemplate("ProductCategory")}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'purchaseitem.series',
        label: 'Termékvásárlás (sorozat szerint)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="series"
                    storeType="remote"
                    placeholder="Sorozat"
                    label={false}
                    optionsTemplate={optionsTemplate("series")}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'purchaseitem.pos',
        label: 'Termékvásárlás (eladási hely szerint)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <div className="flex-grow-6">
                <Select
                    component="PointOfSale"
                    storeType="local"
                    placeholder="Eladási hely"
                    label={false}
                    optionsTemplate={optionsTemplate("PointOfSale")}
                    value={props.value}
                    objectValue={false}
                    disabled={props.disabled}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'purchaseitem.created_at',
        label: 'Termékvásárlás (rögzítés időpontja szerint)',
        operators: [
            { name: '=', label: '=' },
            { name: '!=', label: '!=' },
            { name: '<', label: '<' },
            { name: '>', label: '>' },
            { name: '<=', label: '<=' },
            { name: '>=', label: '>=' },
            { name: 'between', label: 'között' },
        ],
        valueEditor: (props) => {
            if (props.operator === "between") {
                const values = JSON.parse(JSON.stringify(Array.isArray(props.value) ? props.value : (props.value ? [props.value, null] : [null, null])));
                return <Fragment>
                    <div className="flex-grow-1">
                        <DateTimeInput
                            label={false}
                            value={(values[0] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[0] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                    <div className="flex-grow-1">
                        <DateTimeInput
                            label={false}
                            value={(values[1] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[1] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                </Fragment>
            }
            return <div className="flex-grow-1">
                <DateTimeInput
                    label={false}
                    value={props.value}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
    {
        name: 'purchaseitem.transaction_date',
        label: 'Termékvásárlás (elszámolás időpontja szerint)',
        operators: [
            { name: '=', label: '=' },
            { name: '!=', label: '!=' },
            { name: '<', label: '<' },
            { name: '>', label: '>' },
            { name: '<=', label: '<=' },
            { name: '>=', label: '>=' },
            { name: 'between', label: 'között' },
        ],
        valueEditor: (props) => {
            if (props.operator === "between") {
                const values = JSON.parse(JSON.stringify(Array.isArray(props.value) ? props.value : (props.value ? [props.value, null] : [null, null])));
                return <Fragment>
                    <div className="flex-grow-1">
                        <DateTimeInput
                            label={false}
                            value={(values[0] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[0] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                    <div className="flex-grow-1">
                        <DateTimeInput
                            label={false}
                            value={(values[1] || null)}
                            disabled={props.disabled}
                            saveChanges={(field, value) => {
                                values[1] = value;
                                props.handleOnChange(values);
                            }}
                        />
                    </div>
                </Fragment>
            }
            return <div className="flex-grow-1">
                <DateTimeInput
                    label={false}
                    value={props.value}
                    saveChanges={(field, value) => {
                        props.handleOnChange(value);
                    }}
                />
            </div>;
        }
    },
];

const operators = [
    { name: 'null', label: 'is null' },
    { name: 'notNull', label: 'is not null' },
    { name: 'in', label: 'in' },
    { name: 'notIn', label: 'not in' },
    { name: '=', label: '=' },
    { name: '!=', label: '!=' },
    { name: '<', label: '<' },
    { name: '>', label: '>' },
    { name: '<=', label: '<=' },
    { name: '>=', label: '>=' },
    { name: 'contains', label: 'contains' },
    { name: 'beginsWith', label: 'begins with' },
    { name: 'endsWith', label: 'ends with' },
    { name: 'doesNotContain', label: 'does not contain' },
    { name: 'doesNotBeginWith', label: 'does not begin with' },
    { name: 'doesNotEndWith', label: 'does not end with' }
];

const combinators = [
    { name: 'and', label: 'És' },
    { name: 'or', label: 'Vagy' }
];


const controlElements = (props) => {
    const disabled = props.disabled;
    return {
        addGroupAction: (props) => !disabled && <Button disabled={disabled} className="rule-group-add" icon={{lib: "fas", name: "layer-group"}} onClick={props.handleOnClick} color="default" tooltip={props.title} />,
        removeGroupAction: (props) => !disabled && <Button disabled={disabled} className="rule-group-remove" icon={{lib: "fa", name: "times-circle"}} onClick={props.handleOnClick} color="default" tooltip={props.title}/>,
        addRuleAction: (props) => !disabled && <Button disabled={disabled} className="rule-add" icon={{lib: "fa", name: "plus"}} onClick={props.handleOnClick} color="default" tooltip={props.title} />,
        removeRuleAction: (props) => !disabled && <Button disabled={disabled} className="rule-remove" onClick={props.handleOnClick} color="default" tooltip={props.title} icon={empty(props.label) ? {lib: "fa", name: "times-circle"}: undefined}>{props.label}</Button>,
        combinatorSelector: (props) => !disabled && <div className={props.className}><Select disabled={disabled} label={false} storeType="local" options={props.options} labelKey="label" valueKey="name" value={props.value} objectValue={false} saveChanges={(field, value) => props.handleOnChange(value)} /></div>,
        fieldSelector: (props) => <div className={props.className}>
            <Select
                label={false}
                storeType="local"
                options={props.options}
                labelKey="label"
                valueKey="name"
                value={props.value}
                objectValue={false}
                disabled={disabled}
                saveChanges={(field, value) => props.handleOnChange(value)}
            />
        </div>,
        valueEditor: (props) => {
            const operator = (props?.fieldData?.operators || []).find((option) => option.name === props.operator);
            if (!operator) {
                return null;
            }
            if (props.fieldData && props.fieldData.valueEditor) {
                const Editor = props.fieldData.valueEditor;
                return <Editor {...props} disabled={disabled} />;
            } else {
                return <ValueEditor {...props} disabled={disabled} />;
            }
        },
        operatorSelector: (props) => {
            return <div className={props.className}>
                <Select
                    label={false}
                    storeType="local"
                    options={(props.fieldData || {}).operators || props.options}
                    labelKey="label"
                    valueKey="name"
                    value={props.value}
                    objectValue={false}
                    disabled={disabled}
                    saveChanges={(field, value) => props.handleOnChange(value)}
                />
            </div>
        },
        notToggle: (props) => !disabled && <div className={props.className}>
            <CheckBox
                disabled={disabled}
                value={props.checked}
                checked={props.checked}
                label={props.title}
                saveChanges={() => {
                    props.handleOnChange(!props.checked);
                }}
            />
        </div>
    };
};

const controlClassnames = {
    ruleGroup: "",
    header: "",

    rule: "",
    fields: "",
    operators: "",
    value: "",
    removeRule: "",
};

const translations = {
    fields: {
        title: "Mezők",
    },
    operators: {
        title: "Operator",
    },
    value: {
        title: "Érték",
    },
    removeRule: {
        label: "",
        title: "Mező törlés",
    },
    removeGroup: {
        label: "",
        title: "Csoport törlés",
    },
    addRule: {
        label: "Mező",
        title: "Mező hozzáadása",
    },
    addGroup: {
        label: "Csoport",
        title: "Csoport hozzáadása",
    },
    combinators: {
        title: "Kapcsolat",
    },
    notToggle: {
        title: "Tagadás",
    }
};

class QueryBuilder extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: !!this.props.opened,
            filters: false,
            save: null,
            load: null,
            filter: null
        };
        this.componentDidUpdate({},{},{});
        this.saveChanges = debounce((query) => {
            this.props.saveChanges(this.props.name, parseQuery(JSON.parse(formatQuery(query, 'json_without_ids'))));
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.opened !== prevProps.opened) {
            this.setState({opened: this.props.opened});
        }
        if (JSON.stringify(this.props.value) !== JSON.stringify(prevProps.value) || this.props.component !== prevProps.component) {
            this.filter && this.filter.abort();
            if (this.props.value && this.props.component) {
                this.filter = loadComponent("NewsletterFilter", {
                    filter: [
                        {field: "component_type", value: this.props.component},
                        {field: "filter", value: JSON.stringify(this.props.value)}
                    ]
                });
                this.filter.then((filter) => {
                    if (filter.id) {
                        this.setState({filter, load: this.state.filters ? this.state.load : filter});
                    } else {
                        this.setState({filter: null, load: this.state.filters ? this.state.load : null});
                    }
                })
            } else {
                this.setState({filter: null, load: this.state.filters ? this.state.load : null});
            }
        }
    }

    render() {
        const query = this.props.value ? (typeof this.props.value === "string" ? unparseQuery(JSON.parse(this.props.value)) : unparseQuery(JSON.parse(JSON.stringify(this.props.value)))) : {
            combinator: "and",
            not: false,
            rules: []
        };
        if (!query.rules) {
            query.rules = [];
            query.combinator = query.combinator || "and";
            query.not = query.not !== undefined ? query.not : false;
        }
        const currentFields = this.props.fields || optinFields;
        const disabled = this.props.disabled || this.props.isLoading;
        if (!this.controlElements || this.controlElements.disabled !== this.props.disabled) {
            this.controlElements = controlElements({disabled: this.props.disabled});
            this.controlElements.disabled = this.props.disabled;
        }
        return (
            <div className="form-group">
                {this.props.opened === undefined && <Button block={true} color="default" onClick={() => this.setState({opened: !this.state.opened})}>
                    {this.props.tabLabel || "Szűrő"}<span className="caret"/>
                </Button>}
                <Collapse collapsed={this.state.opened}>
                    <div className={classNames("query-builder", {"save-import": this.props.component}, this.props.className)}>
                        <Builder
                            fields={currentFields}
                            query={query}
                            combinators={combinators}
                            operators={operators}
                            onQueryChange={(query) => {
                                if (this.props.disabled) return;
                                this.saveChanges(query);
                            }}
                            showCombinatorsBetweenRules={true}
                            showNotToggle={false}
                            controlClassnames={controlClassnames}
                            translations={translations}
                            controlElements={this.controlElements}
                            resetOnFieldChange={true}
                            resetOnOperatorChange={true}
                        />
                        <div className="clearfix" />
                        {this.props.component && <Fragment>
                            <Button
                                color="default"
                                className="saved-filters-btn"
                                disabled={disabled}
                                icon={{lib: "fas", name: "bookmark"}}
                                onClick={() => {
                                    this.setState({filters: true});
                                }}
                            >
                                Mentett szűrők
                            </Button>
                            <Portal>
                                <Modal
                                    state={!!this.state.deleteConfirm}
                                    theme="default"
                                    header="Törlés"
                                    buttons={[
                                        {
                                            text: 'Mégse',
                                            props: {color: "default", disabled: disabled},
                                            onClose: true,
                                            onClick: async () => {
                                                try {
                                                    this.setState({deleteConfirm: false});
                                                } catch (e) {

                                                }
                                            }
                                        },
                                        {
                                            text: 'Törlés',
                                            props: {color: "danger", disabled: disabled || !this.state.load},
                                            onClick: async () => {
                                                if (this.props.disabled) return;
                                                await deleteComponent("NewsletterFilter", {
                                                    id: this.state.load.id
                                                });
                                                this.setState({filter: null, load: null, deleteConfirm: false}, () => {
                                                    this.componentDidUpdate({},{},{});
                                                    this.filterList && this.filterList.refresh();
                                                });
                                            }
                                        },
                                    ]}
                                >
                                    Biztosan törlöd ezt a tételt?
                                </Modal>
                            </Portal>
                            <Portal>
                                <Modal
                                    state={this.state.filters}
                                    theme="default"
                                    size="large"
                                    header="Mentett szűrők"
                                    buttons={[
                                        {
                                            text: 'Mégse',
                                            props: {color: "default", disabled: disabled},
                                            onClose: true,
                                            onClick: async () => {
                                                try {
                                                    this.setState({filters: false, load: this.state.filter});
                                                } catch (e) {

                                                }
                                            }
                                        },
                                        {
                                            text: 'Törlés',
                                            className: "pull-left",
                                            props: {color: "danger", disabled: disabled || !this.state.load},
                                            onClick: async () => {
                                                if (this.props.disabled) return;
                                                this.setState({deleteConfirm: true});
                                            }
                                        },
                                        {
                                            text: 'Betöltés',
                                            props: {color: "primary", disabled: disabled || !get(this.state.load, "filter") || get(this.state.load, "id") + "" === "" + get(this.state.filter, "id")},
                                            onClick: async () => {
                                                if (this.props.disabled) return;
                                                this.props.saveChanges(this.props.name, get(this.state.load, "filter"));
                                                this.setState({filters: false, load: this.state.filter});
                                            }
                                        }
                                    ]}
                                >
                                    <ComponentConfig componentName="NewsletterFilter">
                                        <NewsletterFilterList
                                            ref={(filterList) => this.filterList = filterList}
                                            view={["filter"]}
                                            listFilter={[
                                                {field: "component_type", value: this.props.component},
                                                {field: "created_by", value: this.props.user.id}
                                            ]}
                                            selection={this.state.load}
                                            loadForm={(load) => this.setState({load})}
                                        />
                                        {this.state.load && <QueryBuilder
                                            name="filter"
                                            value={get(this.state.load, "filter")}
                                            fields={currentFields}
                                            disabled="disabled"
                                            opened={true}
                                        />}
                                    </ComponentConfig>
                                </Modal>
                            </Portal>
                            <Portal>
                                <Modal
                                    state={this.state.save !== null}
                                    theme="default"
                                    size="small"
                                    header="Mentés"
                                    buttons={[
                                        {
                                            text: 'Mégse',
                                            props: {color: "default", disabled: disabled},
                                            onClose: true,
                                            onClick: async () => {
                                                try {
                                                    this.setState({save: null});
                                                } catch (e) {

                                                }
                                            }
                                        },
                                        {
                                            text: 'Mentés',
                                            props: {color: "primary", disabled: disabled || !get(this.props, "value")},
                                            onClick: async () => {
                                                if (this.props.disabled) return;
                                                await saveComponent("NewsletterFilter", {
                                                    ...this.state.save,
                                                    filter: this.props.value,
                                                    component_type: this.props.component
                                                });
                                                this.componentDidUpdate({},{},{});
                                                this.filterList && this.filterList.refresh();
                                                this.setState({save: null});
                                            }
                                        }
                                    ]}
                                >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <TextInput
                                                    label="Címke"
                                                    name="name"
                                                    value={get(this.state, "save.name")}
                                                    saveChanges={(field, value) => {
                                                        this.setState({save: {...this.state.save, [field]: value}});
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                            </Portal>
                            <Button
                                color="default"
                                disabled={!this.props.value || disabled}
                                className="save-btn"
                                onClick={() => {
                                    this.setState({
                                        save: {
                                            ...(this.state.filter || {})
                                        }
                                    });
                                }}
                            >
                                Szűrő mentése
                            </Button>
                        </Fragment>}
                    </div>
                </Collapse>
                <div className="clearfix" />
            </div>
        );
    }
}

export default connect((state) => {
    return {
        user: state.app.user,
    }
})(QueryBuilder);